import { uniqueId } from "lodash-es";
import News from "~/components/desktop/pages/News";
import { NewsDetail } from "~/components/desktop/pages/NewsDetail";
import AuthorizedPage from "~/detect_devices/AuthorizedPage";
import CheckBHYTLoader from "~/detect_devices/CheckBHYT";
import CheckPatientBeforeCreate from "~/detect_devices/CheckPatientBeforeCreate";
import ChooseFeatureBookingLoader from "~/detect_devices/ChooseFeatureBooking";
import ChooseHospitalLoader from "~/detect_devices/ChooseHospital";
import ChoosePatientLoader from "~/detect_devices/ChoosePatient";
import ClinicLoader from "~/detect_devices/Clinic";
import ContactLoader from "~/detect_devices/Contact";
import Download from "~/detect_devices/Download";
import ElectricInvoicesResultSearchLoader from "~/detect_devices/ElectricInvoicesResultSearch";
import ElectronicInvoicesSearchLoader from "~/detect_devices/ElectronicInvoicesSearch";
import ExamResultNhidonghcm from "~/detect_devices/ExamResult";
import ExamResultQR from "~/detect_devices/ExamResultQR";
import FaqDetailLoader from "~/detect_devices/FaqDetail";
import FaqDetailAppLoader from "~/detect_devices/FaqDetailApp";
import FeeResultSearchLoader from "~/detect_devices/FeeResultSearch";
import FeeSearchLoader from "~/detect_devices/FeeSearch";
import FindBHYTLoader from "~/detect_devices/FindBHYTByScanQrCode";
import FollowUpExamLoader from "~/detect_devices/FollowUpExam";
import FollowUpExamGetInfoByPhone from "~/detect_devices/FollowUpExamGetInfoByPhone";
import HistoryPaymentLoader from "~/detect_devices/HistoryPayment";
import HomePageLoader from "~/detect_devices/Home";
import HuongDan from "~/detect_devices/HuongDan";
import HuongDanApp from "~/detect_devices/HuongDanApp";
import InstructionBHYT from "~/detect_devices/InstructionBHYT";
import InstructionBHYTApp from "~/detect_devices/InstructionBHYTApp";
import InstructionIncorrectBHYT from "~/detect_devices/InstructionIncorrectBHYT";
import InstructionIncorrectBHYTApp from "~/detect_devices/InstructionInCorrectBHYTApp";
import InstructionInCorrectBHYTAppDaLieuHCM from "~/detect_devices/InstructionInCorrectBHYTAppDaLieuHCM";
import InstructionIncorrectBHYTDalieuhcm from "~/detect_devices/InstructionIncorrectBHYTDalieuhcm";
import IntroApp from "~/detect_devices/IntroApp";
import IntroduceLoader from "~/detect_devices/Introduce";
import MedicalBillLoader from "~/detect_devices/MedicalBill";
import MedicalBillListLoader from "~/detect_devices/MedicalBillList";
import MomoWaitingRedirect from "~/detect_devices/MomoRedirect";
import NotificationLoader from "~/detect_devices/Notification";
import NotificationDetailLoader from "~/detect_devices/NotificationDetail";
import PartnerTesting from "~/detect_devices/PartnerTesting";
import PatientCheckPhoneLoader from "~/detect_devices/PatientCheckPhone";
import PatientCreateLoader from "~/detect_devices/PatientCreate";
import PatientForgotCodeLoader from "~/detect_devices/PatientForgotCode";
import PatientRecordsLoader from "~/detect_devices/PatientRecords";
import PatientRecordsDetailLoader from "~/detect_devices/PatientRecordsDetail";
import PatientResultSearchLoader from "~/detect_devices/PatientResultSearch";
import PatientUpdateLoader from "~/detect_devices/PatientUpdate";
import PatientVerifyInfomationLoader from "~/detect_devices/PatientVerifyInfomation";
import PaymentApp from "~/detect_devices/PaymentApp";
import PaymentAppSuccess from "~/detect_devices/PaymentAppSuccess";
import PaymentExamWithQrCode from "~/detect_devices/PaymentExamWithQrCode";
import PaymentFeeMethodLoader from "~/detect_devices/PaymentFeeMethod";
import PaymentFeeResultLoader from "~/detect_devices/PaymentFeeResult";
import PaymentHelps from "~/detect_devices/PaymentHelps";
import PaymentMethodLoader from "~/detect_devices/PaymentMethod";
import PaymentWithQrCode from "~/detect_devices/PaymentWithQrCode";
import PrivacyPolicyLoader from "~/detect_devices/PrivacyPolicy";
import PrivacyPolicyAppLoader from "~/detect_devices/PrivacyPolicyApp";
import ProcedureLoader from "~/detect_devices/Procedure";
import RegisterForBusinessPage from "~/detect_devices/RegisterForBusiness";
import RegisterForPersonalPage from "~/detect_devices/RegisterForPersonal";
import ChooseCalendarLoader from "~/detect_devices/Schedules/ChooseCalendar";
import ChooseDoctorLoader from "~/detect_devices/Schedules/ChooseDoctor";
import ChooseRoomLoader from "~/detect_devices/Schedules/ChooseRoom";
import ChooseServiceLoader from "~/detect_devices/Schedules/ChooseService";
import ChooseSubjectLoader from "~/detect_devices/Schedules/ChooseSpecialty";
import SelectedVacxinNhidonghcm from "~/detect_devices/SelectedVacxinNhidonghcmApp";
import TermsOfServiceLoader from "~/detect_devices/TermsOfService";
import TermsOfServiceAppLoader from "~/detect_devices/TermsOfServiceApp";
import TransferInformationLoader from "~/detect_devices/TransferInformation";
import TrustInformationLoader from "~/detect_devices/TrustInformation";
import UsageRulesLoader from "~/detect_devices/UsageRules";
import UsageRulesAppLoader from "~/detect_devices/UsageRulesApp";
import UserLoader from "~/detect_devices/User";

// list route dynamic
const listRouteDynamic = [
  {
    id: "chon-hinh-thuc-dat-kham",
    path: "/chon-hinh-thuc-dat-kham",
    component: ChooseFeatureBookingLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "chon-dich-vu",
    path: "/chon-dich-vu",
    component: ChooseServiceLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "chon-bac-si",
    path: "/chon-bac-si",
    component: ChooseDoctorLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "chon-chuyen-khoa",
    path: "/chon-chuyen-khoa",
    component: ChooseSubjectLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "chon-phong-kham",
    path: "/chon-phong-kham",
    component: ChooseRoomLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "chon-lich-kham",
    path: "/chon-lich-kham",
    component: ChooseCalendarLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "xac-nhan-thong-tin",
    path: "/xac-nhan-thong-tin",
    component: TrustInformationLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "hinh-thuc-thanh-toan",
    path: "/hinh-thuc-thanh-toan",
    component: PaymentMethodLoader,
    authorized: true,
    breadcrumb: true,
    exact: true
  },

  {
    id: "huong-dan-bao-hiem-y-te-dung-tuyen",
    path: "/huong-dan-bao-hiem-y-te-dung-tuyen",
    component: InstructionBHYT,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "huong-dan-bao-hiem-y-te-trai-tuyen",
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen",
    component: InstructionIncorrectBHYT,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: uniqueId(),
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-dalieuhcm",
    component: InstructionIncorrectBHYTDalieuhcm,
    authorized: false,
    childDynamic: null,
    breadcrumb: true,
    exact: false
  },
  {
    id: uniqueId(),
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-app-dalieuhcm/:id/:date",
    component: InstructionInCorrectBHYTAppDaLieuHCM,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: uniqueId(),
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-app-confirm-dalieuhcm/:id/:date",
    component: InstructionInCorrectBHYTAppDaLieuHCM,
    authorized: false,
    childDynamic: null,
    exact: false
  }
];

// ------------------------------Giải thích--------------------------
// - có nghĩa là dùng lại router ban đầu thêm thuốc tính childDynamic
// - thực hiện mapping lại dữ liệu
// - ví dụ: /tvmbaclieu/chon-dich-vu <--> partnerId/pathName
// - sau khi có được listRoutePartner, thì chúng ta sẽ cộng 2 mảng này lại listRouters + listRouteDynamic

// list route partner
const listRoutePartner = PartnerDomain => {
  return PartnerDomain.map(({ partnerId }) => ({
    id: partnerId,
    path: `/${partnerId}`,
    childDynamic: listRouteDynamic.map(current => {
      return {
        ...current,
        id: `${partnerId}-${current.id}`
      };
    })
  }));
};

// list total route
const listRoutersDefault = [
  {
    id: 1,
    path: "/",
    component: HomePageLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },

  {
    id: 2,
    path: "/chon-benh-vien",
    component: ChooseHospitalLoader,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 12,
    path: "/tin-tuc",
    component: News,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 5,
    path: "/tin-tuc/:slug",
    component: NewsDetail,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 8,
    path: "/chon-ho-so",
    component: ChoosePatientLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 13,
    path: "/quy-trinh",
    component: ProcedureLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 14,
    path: "/thac-mac",
    component: FaqDetailLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 15,
    path: "/thac-mac-app",
    component: FaqDetailAppLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 16,
    path: "/dieu-khoan-dich-vu",
    component: TermsOfServiceLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 17,
    path: "/dieu-khoan-dich-vu-app",
    component: TermsOfServiceAppLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 18,
    path: "/chinh-sach-bao-mat",
    component: PrivacyPolicyLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 19,
    path: "/chinh-sach-bao-mat-app",
    component: PrivacyPolicyAppLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 20,
    path: "/quy-dinh-su-dung",
    component: UsageRulesLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 21,
    path: "/quy-dinh-su-dung-app",
    component: UsageRulesAppLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 22,
    path: "/lien-he",
    component: ContactLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 23,
    path: "/gioi-thieu",
    component: IntroduceLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: uniqueId(),
    path: "/gioi-thieu-app",
    component: IntroApp,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },

  {
    id: 26,
    path: "/huong-dan-bao-hiem-y-te-dung-tuyen-app/:id",
    component: InstructionBHYTApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 261,
    path: "/huong-dan-bao-hiem-y-te-dung-tuyen-app-confirm/:id",
    component: InstructionBHYTApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 27,
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-app/:id",
    component: InstructionIncorrectBHYTApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },

  {
    id: 271,
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-app-confirm/:id",
    component: InstructionIncorrectBHYTApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: uniqueId(),
    path: "/chon-loai-vac-xin-nhidong-hcm-app",
    component: SelectedVacxinNhidonghcm,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: uniqueId(),
    path: "/tra-ket-qua-nhidong-hcm-app",
    component: ExamResultNhidonghcm,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 28,
    path: "/authorized/:id",
    component: AuthorizedPage,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 29,
    path: "/user",
    component: UserLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 30,
    path: "/ho-so-benh-nhan",
    component: PatientRecordsLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 31,
    path: "/phieu-kham-benh",
    component: MedicalBillLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 32,
    path: "/lich-su-thanh-toan-vien-phi",
    component: HistoryPaymentLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 33,
    path: "/thong-bao",
    component: NotificationLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 34,
    path: "/thong-bao/detail",
    component: NotificationDetailLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 35,
    path: "/ho-tro-thanh-toan",
    component: TransferInformationLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 36,
    path: "/xac-thuc-dien-thoai-benh-nhan",
    component: PatientCheckPhoneLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 37,
    path: "/xac-nhan-thong-tin-benh-nhan",
    component: PatientVerifyInfomationLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 38,
    path: "/tim-lai-ma-benh-nhan",
    component: PatientForgotCodeLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 39,
    path: "/ket-qua-tim-benh-nhan",
    component: PatientResultSearchLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 40,
    path: "/tao-moi-ho-so",
    component: PatientCreateLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 41,
    path: "/cap-nhat-thong-tin",
    component: PatientUpdateLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 42,
    path: "/chi-tiet-phieu-kham-benh",
    component: MedicalBillListLoader,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 43,
    path: "/phieu-kham-benh/chi-tiet/:code",
    component: MedicalBillListLoader,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 44,
    path: "/ho-so-benh-nhan/chi-tiet/:id",
    component: PatientRecordsDetailLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 45,
    path: "/reexam/:id",
    component: FollowUpExamLoader,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 46,
    path: "/tim-ma-thanh-toan-vien-phi",
    component: FeeSearchLoader,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: false
  },
  {
    id: 47,
    path: "/chi-tiet-ma-thanh-toan",
    component: FeeResultSearchLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 481,
    path: "/hinh-thuc-thanh-toan-vien-phi",
    component: PaymentFeeMethodLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 482,
    path: "/quet-ma-qrcode-thanh-toan-vien-phi",
    component: PaymentWithQrCode,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 483,
    path: "/quet-ma-qrcode-thanh-toan-phieu-kham",
    component: PaymentExamWithQrCode,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 49,
    path: "/ket-qua-thanh-toan-vien-phi",
    component: PaymentFeeResultLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 50,
    path: "/chi-tiet-thanh-toan-vien-phi/:code",
    component: PaymentFeeResultLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 51,
    path: "/check-bhyt",
    component: CheckBHYTLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 52,
    path: "/find-bhyt",
    component: FindBHYTLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 53,
    path: "/check-patient-before-create",
    component: CheckPatientBeforeCreate,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 54,
    path: "/download",
    component: Download,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 55,
    path: "/getapp",
    component: Download,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 55,
    path: "/kq/:id",
    component: ExamResultQR,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 56,
    path: "/tra-cuu-hoa-don-dien-tu",
    component: ElectronicInvoicesSearchLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 57,
    path: "/danh-sach-hoa-don-dien-tu",
    component: ElectricInvoicesResultSearchLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 58,
    path: "/id=:id",
    component: MomoWaitingRedirect,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 59,
    path: "/iframeMomoTesting",
    component: PartnerTesting,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 601,
    path: "/payment-app",
    component: PaymentApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 602,
    path: "/payment-app-success",
    component: PaymentAppSuccess,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 451,
    path: "/reexam",
    component: FollowUpExamGetInfoByPhone,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 62,
    path: "/thanh-toan-ho/:code",
    component: PaymentHelps,
    breadcrumb: true,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 603,
    path: "/khai-bao-ho-so-doanh-nghiep",
    component: RegisterForBusinessPage,
    breadcrumb: true,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 604,
    path: "/khai-bao-ho-so-ca-nhan",
    component: RegisterForPersonalPage,
    breadcrumb: true,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 605,
    path: "/khai-bao-y-te",
    component: RegisterForPersonalPage,
    breadcrumb: true,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: uniqueId(),
    path: "/huong-dan",
    component: HuongDan,
    breadcrumb: false,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: uniqueId(),
    path: "/huong-dan-app",
    component: HuongDanApp,
    breadcrumb: false,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: uniqueId(),
    path: "/clinic",
    component: ClinicLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: uniqueId(),
    path: "/walletId=:walletId",
    component: MomoWaitingRedirect,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  }
];

export const listRouters = PartnerDomain => {
  const list = listRoutersDefault.concat(listRoutePartner(PartnerDomain));
  return list;
};

export default listRouters;
